import type { CompoundEntityRef, Entity } from '@backstage/catalog-model';

import { getCompoundEntityRef } from '@backstage/catalog-model';
import { isEntity, isSolutionEntity } from '@ipen-portal/ipen-entity-model';

export const getEntityCatalogLink = (
  entity: CompoundEntityRef | Entity,
  subPath?: null | string,
) => {
  const ref = isEntity(entity) ? getCompoundEntityRef(entity) : entity;
  let link = `/catalog/${ref.namespace}/${ref.kind.toLowerCase()}/${ref.name}`;
  const resolvedSubPath = subPath ?? (isSolutionEntity(entity) ? 'docs' : null);
  if (resolvedSubPath) {
    link += `/${resolvedSubPath}`;
  }
  return link;
};
